export default __webpack_public_path__ + "static/media/walletconnection.054790c7.jfif";